import { OptionList, Option } from '../../../types/basic';

import { ValueEditorInputProps } from './useValueEditor';

interface UseSelectEditorReturnProps {
  options?: OptionList;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  getSelectEditorValue: (i?: number) => any | undefined;
  handleSelectEditorValueChange: (i?: number) => (option?: Option) => void;
}

export const useSelectEditor = ({
  field,
  values,
  handleSingleValue,
  handleMultipleValues,
}: ValueEditorInputProps): UseSelectEditorReturnProps => {
  return {
    options: field.values,
    getSelectEditorValue: (i = 0) => {
      return values?.[i];
    },
    handleSelectEditorValueChange: (i) => {
      if (i === undefined) {
        return (option) => handleSingleValue(option?.value);
      }

      return (option) => handleMultipleValues(option?.value, i);
    },
  };
};
